import React, { useState, useEffect } from "react";
import axios from "axios";
import Swal from "sweetalert2";
import { Button, Table, Input, Badge } from "reactstrap";

// Historial de lo que Cuory le cambio a las publicaciones en Mercado Libre,
// con el valor de antes para poder revertir.
const nombreEstado = { active: "activa", paused: "pausada" };
const valor = (tipo, v) => (tipo === "Estado" ? nombreEstado[v] || v : tipo === "Precio" && v !== "" ? `$${Number(v).toLocaleString("en-US")}` : v);

function CambiosMeli({ URL, headers, cuentas, error }) {
  const [filas, setFilas] = useState([]);
  const [cuenta, setCuenta] = useState("");
  const [tipo, setTipo] = useState("");
  const [estado, setEstado] = useState("");

  function carga() {
    const p = new URLSearchParams();
    if (cuenta) p.set("cuenta", cuenta);
    if (tipo) p.set("tipo", tipo);
    if (estado) p.set("estado", estado);
    axios
      .get(`${URL}Cambios?${p.toString()}`, { headers })
      .then((res) => setFilas(res.data || []))
      .catch(() => setFilas([]));
  }

  useEffect(() => {
    carga();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [cuenta, tipo, estado]);

  function revierte(c) {
    Swal.fire({
      title: "Revertir cambio",
      html: `${c.tipo} de <b>${c.idPublicacion}</b><br>regresa de <b>${valor(c.tipo, c.despues)}</b> a <b>${valor(c.tipo, c.antes)}</b>`,
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Revertir",
      cancelButtonText: "Cancelar",
    }).then((r) => {
      if (!r.isConfirmed) return;
      axios
        .post(`${URL}CambiosRevertir/${c._id}`, {}, { headers })
        .then(() => {
          Swal.fire({ icon: "success", title: "Revertido", timer: 1300, showConfirmButton: false });
          carga();
        })
        .catch((e) => error(e, "No se pudo revertir"));
    });
  }

  return (
    <>
      <div style={{ display: "flex", gap: 10, marginBottom: 10, flexWrap: "wrap" }}>
        <Input bsSize="sm" type="select" value={cuenta} onChange={(e) => setCuenta(e.target.value)} style={{ width: 200 }}>
          <option value="">Todas las cuentas</option>
          {cuentas
            .filter((c) => c.plataforma === "Mercado Libre")
            .map((c) => (
              <option key={c._id} value={c._id}>
                {c.nombre}
              </option>
            ))}
        </Input>
        <Input bsSize="sm" type="select" value={tipo} onChange={(e) => setTipo(e.target.value)} style={{ width: 150 }}>
          <option value="">Todo</option>
          {["Stock", "Precio", "Estado", "SKU"].map((x) => (
            <option key={x} value={x}>
              {x}
            </option>
          ))}
        </Input>
        <Input bsSize="sm" type="select" value={estado} onChange={(e) => setEstado(e.target.value)} style={{ width: 150 }}>
          <option value="">OK y errores</option>
          <option value="OK">Solo OK</option>
          <option value="Error">Solo errores</option>
        </Input>
        <span style={{ fontSize: 12, color: "#64748b", alignSelf: "center" }}>{filas.length} cambios</span>
      </div>
      <Table size="sm" striped borderless className="table-responsive-xl">
        <thead>
          <tr>
            <th>Fecha</th>
            <th>Cuenta</th>
            <th>Tipo</th>
            <th>Publicacion</th>
            <th>Titulo / SKU</th>
            <th>Antes</th>
            <th>Despues</th>
            <th>Estado</th>
            <th>Origen</th>
            <th></th>
          </tr>
        </thead>
        <tbody>
          {filas.map((c) => (
            <tr key={c._id}>
              <td style={{ fontSize: 12 }}>{new Date(c.createdAt).toLocaleString("es-MX", { dateStyle: "short", timeStyle: "short" })}</td>
              <td>{c.cuentas && c.cuentas.nombre}</td>
              <td>{c.tipo}</td>
              <td style={{ fontSize: 12 }}>
                {c.idPublicacion}
                {c.idVariacion ? <div style={{ color: "#64748b" }}>var. {c.idVariacion}</div> : null}
              </td>
              <td style={{ fontSize: 12, maxWidth: 240 }}>
                {c.titulo}
                {c.sku ? <div style={{ color: "#64748b" }}>{c.sku}</div> : null}
              </td>
              <td>{valor(c.tipo, c.antes)}</td>
              <td>
                <b>{valor(c.tipo, c.despues)}</b>
              </td>
              <td>
                <Badge pill color={c.estado === "OK" ? "success" : c.estado === "Error" ? "danger" : "secondary"} title={c.mensaje}>
                  {c.estado}
                </Badge>
                {c.revertido === "Si" ? (
                  <Badge pill color="info" style={{ marginLeft: 4 }}>
                    revertido
                  </Badge>
                ) : null}
                {c.estado === "Error" && c.mensaje ? <div style={{ fontSize: 10, color: "#b91c1c", maxWidth: 240 }}>{c.mensaje}</div> : null}
              </td>
              <td style={{ fontSize: 12 }}>
                {c.origen}
                {c.user ? <div style={{ color: "#64748b" }}>{c.user}</div> : null}
              </td>
              <td>
                {c.estado === "OK" && c.revertido !== "Si" && c.origen !== "Reversa" ? (
                  <Button size="sm" color="secondary" outline title="Regresar al valor de antes" onClick={() => revierte(c)}>
                    <i class="fas fa-undo"></i>
                  </Button>
                ) : null}
              </td>
            </tr>
          ))}
        </tbody>
      </Table>
      {!filas.length ? <div style={{ fontSize: 13, color: "#94a3b8" }}>Todavia no se ha cambiado nada en Mercado Libre.</div> : null}
    </>
  );
}

export default CambiosMeli;
